import React, { useEffect } from "react";
import './offers.css';
import Aos from 'aos';
import 'aos/dist/aos.css';
import o1 from '../../Assets/disabilityHistoryMonth2024/1.jpg';
import o2 from '../../Assets/OpenDay2025/o3.jpeg';
import p3 from '../../Assets/potentialUnlockAward/p3.jpg'
import p5 from '../../Assets/SocietyofYear/s6.jpg'
const Offer = [
  {
    id: 1,
    imgSrc: o1,
    grade: 'We Connect',
   
  },
  {
    id: 2,
    imgSrc: o2,
    grade: 'We Educate',
  
  },

  {
    id: 3,
    imgSrc: p3,
    grade: 'We Promote',
  
  },

  {
    id: 4,
    imgSrc: p5,
    grade: 'We Mentor',
  }
]

const Offers = () => {

  useEffect(() => {
    Aos.init({ duration: 2000 })
  }, [])
  return (
    <section className="offer container section">
      <div className="secContainer">
        <div data-aos="fade-up" data-aos-duration="2000" className="secIntro">
          <h2 className="secTitle">
         What We Offer
          </h2>
          <p>
          At Legalnable, we offer free and accessible support to help individuals with disabilities understand and protect their legal rights.
          </p>
        </div>

        <div className="mainContent grid">
          {
            Offer.map(({ id, imgSrc, grade, }) => {
              return (
                <div key={id} data-aos="fade-up" data-aos-duration="3000" className="singleOffer">
             
                  <div className="offerBody">
                    <div className="price flex">
                      <h4>
                        {grade}
                      </h4>
                      <br></br>
                      <br></br>
                      <br></br>
                   
                    </div>
                      <div className="destImage">
                    <img src={imgSrc} alt="Image Name" />
                  </div> 
                  
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    </section>

  )

}

export default Offers